import { Api } from './index';

export const fetchSpinnerPrizes = () => Api.get('/wheel');

export const spinSpinner = (data) => Api.post('/orders/spin', data);
